/**
 * Category Service
 * 
 * Handles all category-related API calls.
 */

import api from '../utils/api';

/**
 * Get all categories
 * @param {Object} params - Query parameters (skip, limit, etc.)
 * @returns {Promise} - Get categories response
 */
export const getCategories = async (params = {}) => {
  try {
    const response = await api.get('/v1/categories/', params);

    if (response.status === 'success' && response.data) {
      return {
        success: true,
        data: response.data,
        pagination: response.pagination,
        message: response.message || 'Categories retrieved successfully',
      };
    }

    return {
      success: false,
      error: response.message || 'Failed to retrieve categories',
      data: null,
      pagination: null,
    };
  } catch (error) {
    console.error('Get categories error:', error);
    
    let errorMessage = 'Failed to retrieve categories. Please try again.';
    
    if (error.response) {
      const errorData = error.response;
      if (errorData.error) {
        errorMessage = errorData.error;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    return {
      success: false,
      error: errorMessage,
      data: null,
      pagination: null,
    };
  }
};

/**
 * Get a single category by ID
 * @param {string} categoryId - Category ID
 * @returns {Promise} - Get category response
 */
export const getCategory = async (categoryId) => {
  try {
    const response = await api.get(`/v1/categories/${categoryId}`);

    if (response.status === 'success' && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.message || 'Category retrieved successfully',
      };
    }

    return {
      success: false,
      error: response.message || 'Failed to retrieve category',
      data: null,
    };
  } catch (error) {
    console.error('Get category error:', error);
    
    let errorMessage = 'Failed to retrieve category. Please try again.';
    
    if (error.response) {
      const errorData = error.response;
      if (errorData.error) {
        errorMessage = errorData.error;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    return {
      success: false,
      error: errorMessage,
      data: null,
    };
  }
};

const categoryService = {
  getCategories,
  getCategory,
};
export default categoryService;

